import actions from '../../actionTypes';

export default locations => {
  return {
    type: actions.SET_LOCATIONS_BY_SITE,
    locations
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/setLocationsBySite.js